<template>
  <div class="animated fadeIn">
    <b-alert :variant="dismissibleType"
             dismissible
             :show="showDismissibleAlert"
             @dismissed="showDismissibleAlert=false">
      {{ errMsg }}
    </b-alert>
    <div>
      <b-row>
        <b-col md="8">
          <b-card>
            <template v-slot:header>
              <strong>Dealer Defined Equipment</strong>
            </template>
            <b-table :items="dealerDefinedEquipment" :fields="dealerDefinedEquipmentFields" hover striped bordered small caption-top responsive
                     :filter="filter" @filtered="onFiltered" show-empty :current-page="currentPage2" :per-page="perPage2">
              <template v-slot:table-caption>
                <b-row>
                  <b-col md="1" />
                  <b-col md="4">
                    <b-form-group>
                      <b-input-group>
                        <b-form-input id="inpDealDefEquipSearch" v-model="filter" placeholder="Type to Search" />
                        <b-input-group-append>
                          <b-btn id="btnClearDealDefEquip" :disabled="!filter" @click="filter = ''">Clear</b-btn>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-button id="btnAdd" class="pull-right" variant="outline-success" @click="addDealerEquipment" title="Add">
                      <i class="fa fa-plus-square"></i> <strong>Add</strong>
                    </b-button>
                  </b-col>

                </b-row>
              </template>
              <template v-slot:cell(NewUsedType)="data">
                <slot v-if="!data.item.editEquipment">{{data.item.Type}}</slot>
                <b-form-select v-if="data.item.editEquipment" v-model="data.item.NewUsedType" :options="typeoptions" />
              </template>
              <template v-slot:cell(IsSelected)="data">
                <b-form-checkbox :disabled.sync="!data.item.editEquipment" v-model="data.item.IsSelected"></b-form-checkbox>
              </template>
              <template v-slot:cell(IsSuggested)="data">
                <b-form-checkbox :disabled.sync="!data.item.editEquipment" v-model="data.item.IsSuggested"></b-form-checkbox>
              </template>
              <template v-slot:cell(Name)="data">
                <slot v-if="!data.item.editEquipment">{{data.item.Name}}</slot>
                <b-form-input v-if="data.item.editEquipment" v-model="data.item.Name"
                              v-bind:class="{'is-invalid': validateErrors.has('editdealerName') }" v-validate="{required: true}" name="editdealerName" />
              </template>
              <template v-slot:cell(Cost)="data">
                <slot v-if="!data.item.editEquipment">{{data.item.Cost  | currency('')}}</slot>
                <b-form-input v-if="data.item.editEquipment" v-model="data.item.Cost" name="dCost"
                              v-bind:class="{'is-invalid': validateErrors.has('dCost') }" v-validate="{decimal: 2}" />
              </template>
              <template v-slot:cell(Price)="data">
                <slot v-if="!data.item.editEquipment">{{data.item.Price  | currency('')}}</slot>
                <b-form-input v-if="data.item.editEquipment" v-model="data.item.Price" name="dPrice" v-validate="{decimal: 2}"
                              v-bind:class="{'is-invalid': validateErrors.has('dPrice') }" />
              </template>

              <template v-slot:cell(Tax)="data">
                <b-form-checkbox :disabled.sync="!data.item.editEquipment" v-model="data.item.Tax" @change="taxExemptChanged(data.item)"></b-form-checkbox>
              </template>
              <template v-slot:cell(Actions)="data">
                <button id="btnEditDealDefEquip" class="btn btn-primary text-white mx-1" v-if="!data.item.editEquipment" @click="EditDealerEquipment(data.item)" title="Edit">
                  <i class="fa fa-edit"><strong> Edit</strong></i>
                </button>
                <button id="btnSaveDealDefEquip" class="btn btn-success text-white mx-1" v-if="data.item.editEquipment" @click="SaveDealerEquipment(data.item)" title="Save">
                  <i class="fa fa-save"><strong> Save</strong></i>
                </button>
                <button id="btnDeleteDealDefEquip" class="btn btn-warning text-white mx-1" @click="DeleteDealerEquipment(data.item)" title="Delete">
                  <i class="fa fa-ban"><strong> Delete</strong></i>
                </button>
              </template>

            </b-table>
            <b-row>
              <b-col class="px-0 mx-0">
                <nav>
                  <b-pagination :total-rows="totalRows2" :per-page="perPage2" v-model="currentPage2" prev-text="Prev" next-text="Next" />
                </nav>
              </b-col>
              <b-col><div class="pull-right my-2">Showing {{ totalRows2}} / {{ dealerDefinedEquipment.length }} records</div></b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="8">
          <b-card>
            <template v-slot:header>
              <strong>Vehicle Equipment</strong>
            </template>
            <b-table :items="predefinedEquipment" :fields="predefinedEquipmentFields" hover striped bordered small caption-top responsive
                     :filter="filterPredefined" @filtered="onPredefinedFiltered"
                     :current-page="currentPage" :per-page="perPage" show-empty>
              <template v-slot:table-caption>
                <b-row>
                  <b-col md="1"></b-col>
                  <b-col md="4">
                    <b-form-group class="my-4 ">
                      <b-input-group class="my-1">
                        <b-form-input id="inpSearchVehEquip" v-model="filterPredefined" placeholder="Type to Search" />
                        <b-input-group-append>
                          <b-btn id="btnClearVehEquip" :disabled="!filterPredefined" @click="filterPredefined = ''">Clear</b-btn>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col md="3">
                    <b-form-group label="Specific Make"
                                  label-for="srMake">
                      <b-form-select id="srMake" v-model="search.MakeId" :options="search.Make" @click.native.stop @change="loadModel($event)" />
                    </b-form-group>
                  </b-col>
                  <b-col md="3">
                    <b-form-group label="Specific Model" label-for="srModel">
                      <b-form-select id="srModel" v-model="search.ModelId" :options="search.Model" @change="loadEquipmentByModel($event)" />
                    </b-form-group>
                  </b-col>
                </b-row>
              </template>

              <template v-slot:cell(Factory)="data">
                <b-form-checkbox  :disabled.sync="!data.item.edit" v-model="data.item.Factory"></b-form-checkbox>
              </template>
              <template v-slot:cell(Added)="data">
                <b-form-checkbox  :disabled.sync="!data.item.edit" v-model="data.item.Added"></b-form-checkbox>
              </template>
              <template v-slot:cell(Cost)="data">
                <slot v-if="!data.item.edit">{{data.item.Cost | currency('')}}</slot>
                <b-form-input name="pCost" v-if="data.item.edit" v-model="data.item.Cost"
                              v-bind:class="{'is-invalid': validateErrors.has('pCost') }" v-validate="{required: true, decimal: 2}" />
              </template>
              <template v-slot:cell(Price)="data">
                <slot v-if="!data.item.edit">{{data.item.Price | currency('')}}</slot>
                <b-form-input v-if="data.item.edit" v-model="data.item.Price" name="pPrice" v-validate="{decimal: 2}"
                              v-bind:class="{'is-invalid': validateErrors.has('pPrice') }" />
              </template>
              <template v-slot:cell(Suppressed)="data">
                <b-form-checkbox :disabled.sync="!data.item.edit" v-model="data.item.Suppressed"></b-form-checkbox>
              </template>
              <template v-slot:cell(Actions)="data">
                <button id="btnEditVehEquip" class="btn btn-primary text-white" v-if="!data.item.edit" @click="EditPredefinedEquipment(data.item)" title="Edit">
                  <i class="fa fa-edit"><strong> Edit</strong></i>
                </button>
                <button id="btnSaveVehEquip" class="btn btn-success text-white" v-if="data.item.edit" @click="SavePredefinedEquipment(data.item)" title="Save">
                  <i class="fa fa-save"><strong> Save</strong></i>
                </button>
              </template>

            </b-table>
            <b-row>
              <b-col class="px-0 mx-0">
                <nav>
                  <b-pagination :total-rows="predefinedEquipment.length" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" />
                </nav>
              </b-col>
              <b-col><div class="pull-right my-2">Showing {{ totalRows}} / {{ predefinedEquipment.length }} records</div></b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </div>

    <b-modal ref="addDealerEquipmentModal" size="md" title="Add Equipment" id="addDealerEquipmentModal"
             header-bg-variant="dark" header-text-variant="light"
             ok-title="Add" @ok="modalDealerEquipmentOK($event)">
      <!--@cancel="modalDealerEquipmentCancelled"-->
      <b-container fluid>
        <b-row class="mb-1">
          <b-col class="text-right" cols="4">Type</b-col>
          <b-col><b-form-select id="selTypeModal" v-model="dealerNew.NewUsedType" :options="typeoptions" /></b-col>
        </b-row>
        <b-row class="mb-1">
          <b-col class="text-right" cols="4">Name</b-col>
          <b-col class="pull-left">
            <b-form-input id="inpNameModal" v-model="dealerNew.Name" v-bind:class="{'is-invalid': validateErrors.has('Name') }" v-validate="{required: true}" name="Name" />
            <em class="error invalid-feedback">{{ validateErrors.first('Name') }}</em>
          </b-col>
        </b-row>
        <b-row class="mb-1">
          <b-col class="text-right" cols="4">Cost</b-col>
          <b-col>
            <b-form-input id="inpCostModal" v-model="dealerNew.Cost" name="aCost"
                          v-bind:class="{'is-invalid': validateErrors.has('aCost') }" v-validate="{decimal: 2}" />
          </b-col>
        </b-row>
        <b-row class="mb-1">
          <b-col class="text-right" cols="4">Price</b-col>
          <b-col>
            <b-form-input id="inpPriceModal" v-model="dealerNew.Price" name="aPrice" v-validate="{decimal: 2}"
                          v-bind:class="{'is-invalid': validateErrors.has('aPrice') }" />
          </b-col>
        </b-row>
        <b-row class="mb-1">
          <b-col class="text-right" cols="4" style="padding:0px;">Installed By Default</b-col>
          <b-col><b-form-checkbox id="chkInstByDefModal" v-model="dealerNew.IsSelected"></b-form-checkbox></b-col>
        </b-row>
        <b-row class="mb-1">
          <b-col class="text-right" cols="4">Suggested</b-col>
          <b-col><b-form-checkbox id="chkSuggestedModal" v-model="dealerNew.IsSuggested"></b-form-checkbox></b-col>
        </b-row>
        <b-row class="mb-1">
          <b-col class="text-right" cols="4">Tax</b-col>
          <b-col><b-form-checkbox id="chkTaxModal" v-model="dealerNew.Tax" @change="taxExemptChanged(dealerNew)"></b-form-checkbox></b-col>
        </b-row>
      </b-container>
    </b-modal>

    <loading :show="boolLoading" label="Loading..."></loading>
  </div>
</template>

<script>
// import Vue from 'vue'
import axios from 'axios'
import loading from 'vue-full-loading'

export default {
  components: {
    loading
  },
  created () {
    var self = this
    self.boolLoading = true
    self.resetDealerEquipment()
    axios.get('/api/vehicleequipment/loadequipment')
      .then(response => {
        self.boolLoading = false
        self.predefinedEquipment = response.data.predefinedEquipment.map(x => {
          x['edit'] = false
          return x
        })
        self.loadDealerData(response.data.dealerDefinedEquipment)
        self.search.Make = response.data.makes
        self.totalRows = self.dealerDefinedEquipment.length
      })
      .catch(error => {
        self.SetErrorMsg(error, 'getting')
      })
  },
  data () {
    return {
      errMsg: '',
      dismissibleType: 'danger',
      showDismissibleAlert: false,
      boolLoading: false,
      filterPredefined: null,
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      predefinedEquipment: [],
      predefinedEquipmentFields: [
        // { key: 'AddCode', label: 'AddCode' },
        { key: 'Factory', label: 'Factory Part', tdClass: 'w100', sortable: true },
        { key: 'Added', label: 'Installed By Default', tdClass: 'w100', sortable: true },
        { key: 'Name', label: 'Name', sortable: true },
        { key: 'Cost', label: 'Cost', tdClass: 'w100', sortable: true },
        { key: 'Price', label: 'Price', tdClass: 'w100', sortable: true },
        { key: 'Suppressed', label: 'Hidden', tdClass: 'w100', sortable: true },
        { key: 'Actions', label: 'Actions', sortable: false, tdClass: 'w100' }
      ],
      typeoptions: [
        { value: -1, text: 'All' },
        { value: 1, text: 'New' },
        { value: 0, text: 'Used' }
      ],
      dealerDefinedEquipment: [],
      dealerDefinedEquipmentFields: [
        // { key: 'ID', label: 'ID' },
        { key: 'NewUsedType', label: 'New / Used', tdClass: 'w100', sortable: true },
        { key: 'IsSuggested', label: 'Suggested', tdClass: 'w100', sortable: true },
        { key: 'IsSelected', label: 'Installed By Default', tdClass: 'w100', sortable: true },
        { key: 'Name', label: 'Name', sortable: true },
        { key: 'Cost', label: 'Cost', tdClass: 'w100', sortable: true },
        { key: 'Price', label: 'Price', tdClass: 'w100', sortable: true },
        { key: 'Tax', label: 'Tax', tdClass: 'w100', sortable: true },
        { key: 'Actions', label: 'Actions', sortable: false, tdClass: 'w150' }
      ],
      filter: null,
      currentPage2: 1,
      perPage2: 10,
      totalRows2: 0,
      editEquipment: true,
      dealerNew: null,
      search: { MakeId: 0, Make: [{ value: 0, text: 'Any' }], ModelId: 0, Model: [{ value: 0, text: 'Any' }] }
    }
  },
  methods: {
    loadModel (arg) {
      var self = this
      self.boolLoading = true
      self.search.Model = []
      axios.get('/api/vehicleequipment/loadmodels?makeId=' + arg)
        .then(response => {
          self.boolLoading = false
          self.search.Model = response.data
        })
        .catch(error => {
          self.SetErrorMsg(error, 'getting')
        })
    },
    loadEquipmentByModel (arg) {
      var self = this
      self.boolLoading = true
      self.predefinedEquipment = []
      axios.get('/api/vehicleequipment/loadequipmentbymodel?modelId=' + arg)
        .then(response => {
          self.boolLoading = false
          self.predefinedEquipment = response.data.predefinedEquipment.map(x => {
            x['edit'] = false
            return x
          })
        })
        .catch(error => {
          self.SetErrorMsg(error, 'getting')
        })
    },
    onFiltered (filteredItems) {
      this.totalRows2 = filteredItems.length
      this.currentPage2 = 1
    },
    onPredefinedFiltered (filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    taxExemptChanged (e) {
      e.TaxExempt = e.Tax
    },
    addDealerEquipment () {
      this.resetDealerEquipment()
      this.$refs.addDealerEquipmentModal.show()
    },
    modalDealerEquipmentOK (arg) {
      arg.preventDefault()

      var self = this
      Promise.all([
        this.$validator.validate('Name', self.dealerNew.Name),
        this.$validator.validate('aCost', self.dealerNew.Cost),
        this.$validator.validate('aPrice', self.dealerNew.Price)
      ]).then(values => {
        if (values.every(value => { return value })) {
          self.$refs.addDealerEquipmentModal.hide()
          self.boolLoading = true
          axios.post('/api/vehicleequipment/dealerdefined/save', self.dealerNew)
            .then(response => {
              self.boolLoading = false
              self.resetDealerEquipment()
              self.loadDealerData(response.data)
            })
            .catch(error => {
              self.SetErrorMsg(error, 'saving')
            })
        }
      })
    },
    resetDealerEquipment () {
      this.dealerNew = { NewUsedType: -1, ID: 0, Name: '', Cost: '', Price: '', IsSelected: false, IsSuggested: false, Tax: true, TaxExempt: false, editEquipment: false }
      this.validateErrors.clear()
    },
    SaveDealerEquipment (item) {
      var self = this
      Promise.all([
        this.$validator.validate('editdealerName', item.Name),
        this.$validator.validate('dCost', item.Cost),
        this.$validator.validate('dPrice', item.Price)
      ]).then(values => {
        if (values.every(value => { return value })) {
          self.boolLoading = true
          axios.post('/api/vehicleequipment/dealerdefined/save', item)
            .then(response => {
              self.boolLoading = false
              self.loadDealerData(response.data)
            })
            .catch(error => {
              self.SetErrorMsg(error, 'saving')
            })
        }
      })
    },
    SetErrorMsg (error, action) {
      var self = this

      if (error.response.status === 403 && error.response.statusText.indexOf('403.1') === -1) { self.$router.push('/login') }

      self.boolLoading = false

      self.errMsg = 'There was an error ' + action + ' your changes : '
      if (error !== undefined && error.response !== undefined && error.response.statusText !== undefined) {
        self.errMsg = self.errMsg + error.response.statusText
      } else {
        self.errMsg = self.errMsg + error
      }

      self.dismissibleType = 'danger'
      self.showDismissibleAlert = true

      if (error.response.status === 403 && error.response.statusText.indexOf('403.1') !== -1) { self.errMsg = error.response.statusText.replace('403.1', '') }
    },
    EditDealerEquipment (item) {
      item.editEquipment = !item.editEquipment
    },

    SavePredefinedEquipment (item) {
      var self = this

      if (!item) {
        self.errMsg = 'Unknown error.'
        self.showDismissibleAlert = true
        return
      }

      Promise.all([
        this.$validator.validate('pCost', item.Cost),
        this.$validator.validate('pPrice', item.Price)
      ]).then(values => {
        // console.log(JSON.stringify(values));

        if (values.every(value => { return value })) {
          self.boolLoading = true

          axios.post('/api/vehicleequipment/predefined/save?modelId=' + self.search.ModelId, item)
            .then(response => {
              self.errMsg = 'Vehicle Equipment Saved'
              self.dismissibleType = 'success'
              self.showDismissibleAlert = true

              self.boolLoading = false
              item.edit = !item.edit
              self.predefinedEquipment = response.data.map(x => {
                x['edit'] = false
                return x
              })
            })
            .catch(error => {
              self.SetErrorMsg(error, 'saving')
            })
        }
      })
    },
    EditPredefinedEquipment (item) {
      item.edit = !item.edit
    },
    DeleteDealerEquipment (item) {
      var self = this
      self.boolLoading = true
      axios.post('/api/vehicleequipment/dealerdefined/delete?equipmentId=' + item.ID)
        .then(response => {
          self.boolLoading = false
          self.loadDealerData(response.data)
        })
        .catch(error => {
          self.SetErrorMsg(error, 'saving')
        })
    },
    loadDealerData (data) {
      var d = data.map(x => {
        x['Type'] = x['NewUsedType'] === -1 ? 'All' : x['NewUsedType'] === 1 ? 'New' : 'Used'
        x['Tax'] = !x['TaxExempt']
        x['editEquipment'] = false
        return x
      })
      this.dealerDefinedEquipment = d
    }
  },
  mounted () {
    // boolLoading must be set to false on data() binding so that mount hooks the change
    this.boolLoading = true
  }
}
</script>

<style>
  .table > tbody > tr > td {
    vertical-align: middle;
  }

  .blue {
    background-color: lightblue;
  }

  .w100 {
    width: 100px;
  }

  .w150 {
    width: 180px;
  }

  .row {
    margin: 0;
    padding: 0
  }
</style>



// WEBPACK FOOTER //
// src/views/VehicleEquipment.vue